const setBlock = ($menu, $header) => {
  let h = $menu.offsetHeight
  $header.style.paddingTop = h + 'px';
}

const headerBlockSpace = () => {
  let $menu = document.querySelector('.main-header'),
      $header = document.querySelector('.blog-single--header'),
      resizeTimer

  setBlock($menu, $header)
  window.addEventListener('resize', () => {
    clearInterval(resizeTimer)
    resizeTimer = setTimeout(() => {
      setBlock($menu, $header)
    }, 250)
  })
}
export default headerBlockSpace
